export default __webpack_public_path__ + "static/media/Modified_Lloyds_Davies_Male.a09e70da.png";